import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Route, Link } from 'react-router-dom'

import { selectCurrentApplication } from '../Applications/selectors'
import { getApplyToStepPath } from '../MainRoutes/utils'

import StepNavItem from '../../components/StepNav/StepNavItem'

const mapStateToProps = createStructuredSelector({
  application: selectCurrentApplication
})

const connector = connect(mapStateToProps)

export const renderStep = props => ({ match }) => (
  <StepNavItem
    current={!!match}
    as={Link}
    {...props}
  />
)

function RouteStepNav({
  path,
  exact,
  strict,
  location,
  sensitive,
  dispatch,
  application,
  step,
  ...props
}) {
  return (
    <Route
      path={path}
      exact={exact}
      strict={strict}
      location={location}
      sensitive={sensitive}
      children={renderStep({
        ...props,
        to: getApplyToStepPath(step, application),
        disabled: step > application.status
      })}
    />
  )
}

RouteStepNav.propTypes = {
  path: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.sting),
    PropTypes.string
  ]).isRequired,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  location: PropTypes.object,
  sensitive: PropTypes.bool
}

export default connector(RouteStepNav)
